import { Offcanvas } from 'react-bootstrap'

type sitioOffcanva = {
  idSitio: string
  nombre: string
  razonSocial: string
  rfc: string
  descRazonSocial: string
}

type Props = {
  mostrarOffcanvaSitios: boolean
  cerrarOffcanvaSitios: () => void
  usuario: any
}

/**
 * Offcanvas de solo lectura que muestra los sitios asignados a un usuario.
 * Se activa desde el listado (icono de ubicacion en cada fila).
 */
export const OffcanvasSitiosUsuarios = ({
  mostrarOffcanvaSitios,
  cerrarOffcanvaSitios,
  usuario,
}: Props) => {
  return (
    <Offcanvas
      show={mostrarOffcanvaSitios}
      onHide={cerrarOffcanvaSitios}
      scroll={true}
      placement='end'>
      <Offcanvas.Header closeButton style={{ backgroundColor: '#0062A9' }}>
        <div className='d-flex flex-column'>
          <h2 className='text-white'>Sitios</h2>
          <h4 className='d-flex text-gray-300 mt-2'>{`${usuario.nombre} ${usuario.apellido}`}</h4>
        </div>
      </Offcanvas.Header>
      <Offcanvas.Body>
        {mostrarOffcanvaSitios &&
          usuario.sitios.map((sitio: sitioOffcanva, index: number) => (
            <div key={sitio.idSitio}>
              <div className='p-4 fs-4'>
                <div className='d-flex flex-column'>
                  <p className='pb-2 fs-2 fw-bolder'>{sitio.nombre}</p>
                  <p className='pb-2'>{sitio.descRazonSocial}</p>
                  <p className='pb-2'>{sitio.rfc} </p>
                </div>
                {index !== usuario.sitios.length - 1 && (
                  <div className='separator separator-dashed mt-4'></div>
                )}
              </div>
            </div>
          ))}
      </Offcanvas.Body>
    </Offcanvas>
  )
}
